import {callsApi} from './api';
import CardReasonInfo from 'records/CardReasonInfo';
import CardReasonScheme from 'records/CardReasonScheme';
import {List} from 'immutable';

export default {
  fetchAll() {
    return callsApi
      .getJson(`/scorecard-reasons/`)
      .then(reasonsInfo => List(reasonsInfo.map(reasonsInfo => new CardReasonInfo(reasonsInfo))));
  },

  fetchCardReasonScheme(cardReasonSchemeId) {
    return callsApi
      .getJson(`/scorecard-reasons/${cardReasonSchemeId}`)
      .then(scheme => new CardReasonScheme(scheme));
  },

  deleteCardReasonScheme(cardReasonSchemeId) {
    return callsApi.delete(`/scorecard-reasons/${cardReasonSchemeId}`);
  },

  createCardReasonScheme(cardScheme) {
    return callsApi
      .postJson(`/scorecard-reasons/`, cardScheme.toJS())
      .then(scheme => new CardReasonInfo(scheme));
  },

  updateCardReasonScheme(cardScheme) {
    return callsApi.putJson(`/scorecard-reasons/`, cardScheme.toJS());
  },

  fetchReasonSchemesForScoringScheme(scoringScheme) {
    return callsApi
      .getJson(`/scorecard-reasons?scoringScheme=${scoringScheme}`)
      .then(reasonsInfo => List(reasonsInfo.map(reasonsInfo => new CardReasonInfo(reasonsInfo))));
  },

  fetchReasonSchemesForCall(callId) {
    return callsApi
      .getJson(`/scorecard-reasons?callId=${callId}`)
      .then(reasonsInfo => List(reasonsInfo.map(scheme => new CardReasonScheme(scheme))));
  },

  fetchReasonSchemesForScorecard(scorecardId) {
    return callsApi
      .getJson(`/scorecard-reasons?scorecardId=${scorecardId}`)
      .then(reasonsInfo => List(reasonsInfo.map(scheme => new CardReasonScheme(scheme))));
  },

  fetchReasonSchemesForCurrentUser() {
    return callsApi
      .getJson(`/scorecard-reasons?forUser=true`)
      .then(reasonsInfo => List(reasonsInfo.map(scheme => new CardReasonScheme(scheme))));
  },
};
